import { Box, Text } from '@chakra-ui/react';

export const HeadingsPreview = () => {
  return (
    <Box>
      <Text>HeadingsPreview - Coming soon</Text>
    </Box>
  );
};
